<label [ngClass]="{ 'ph-input__radio-checked': checked }">
  <input type="radio" [name]="name" [value]="value" (change)="update()" [checked]="checked" />
  <ng-content></ng-content>
</label>
